import React from "react";
import "./MyMapsSymbolizer.css";

export const PointType = (props) => {
	return (
		<React.Fragment>
			<label className={props.visible ? "sc-mymaps-style-label" : "sc-hidden"}>Štýl:</label>
			<select className={props.visible ? "sc-mymaps-style-dropdown" : "sc-hidden"} name="pointSymbols" value={props.selectedPointStyleDropDown} onChange={props.onPointStyleDropDown}>
				<option value="circle">Kruh</option>
				<option value="cross">Kríž</option>
				<option value="square">Štvorec</option>
				<option value="triangle">Trojuholník</option>
				<option value="star">Hviezda</option>
				<option value="x">X</option>
			</select>
		</React.Fragment>
	);
};

export const PolygonType = (props) => {
	return (
		<React.Fragment>
			<label className={props.visible ? "sc-mymaps-style-label" : "sc-hidden"}>Štýl:</label>
			<select className={props.visible ? "sc-mymaps-style-dropdown" : "sc-hidden"} name="polygonSymbols" value={props.selectedPolygonStyleDropDown} onChange={props.onPolygonStyleDropDown}>
				<option value="none">Žiadny</option>
				<option value="solid">Pevný</option>
				<option value="horizontal">Horizontálny</option>
				<option value="vertical">Vertikálny</option>
				<option value="cross">Krížový</option>
			</select>
		</React.Fragment>
	);
};

export const StyleSize = (props) => {
	return (
		<React.Fragment>
			<label className={props.visible ? "sc-mymaps-sub-label" : "sc-hidden"}>Veľkosť:</label>
			<div className={props.visible ? "sc-mymaps-symbolizer-slider size" : "sc-hidden"}>
				<input type="range" style={{ width: "191px" }} min={props.sliderRadiusMin} max={props.sliderRadiusMax} value={props.radius} step="1" onChange={props.onRadiusSliderChange} />
			</div>
		</React.Fragment>
	);
};

export const FillColor = (props) => {
	return (
		<React.Fragment>
			<label className={!props.visible ? "sc-hidden" : props.isPolygon ? "sc-mymaps-style-label" : "sc-mymaps-sub-label"}>Farba:</label>
			<div className={props.visible ? "sc-mymaps-fill-color-button" : "sc-hidden"}>
				<button
					id={props.colorPickerButtonId}
					style={{
						backgroundColor: props.rgbFill,
						width: "30px",
						height: "15px",
						cursor: "pointer",
					}}
					onMouseUp={props.onFillColorPickerButton}
				/>
				<div className="sc-mymaps-symbolizer-slider opacity">
					<input
						key={"sc-mymaps-symbolizer-fill-opacity"}
						type="range"
						style={{ width: "150px", marginLeft: "12px" }}
						min={props.sliderFillOpacityMin}
						max={props.sliderFillOpacityMax}
						value={props.fillAlpha}
						step="0.05"
						onChange={props.onFillOpacitySliderChange}
					/>
				</div>
			</div>
		</React.Fragment>
	);
};

export const StrokeType = (props) => {
	return (
		<React.Fragment>
			<label className="sc-mymaps-style-label">Typ čiary:</label>
			<select className="sc-mymaps-style-dropdown" name="pointOutline" value={props.selectedStrokeTypeDropDown} onChange={props.onStrokeTypeDropDown}>
				<option value="normal">Plná čiara</option>
				<option value="dash">Čiarkovaná</option>
				<option value="dot">Bodkovaná</option>
			</select>
		</React.Fragment>
	);
};

export const StrokeColor = (props) => {
	return (
		<React.Fragment>
			<label className="sc-mymaps-sub-label">Farba:</label>
			<div className="sc-mymaps-fill-color-button">
				<button
					id={props.colorPickerButtonId}
					style={{
						backgroundColor: props.rgbStroke,
						width: "30px",
						height: "15px",
						cursor: "pointer",
					}}
					onMouseUp={props.onStrokeColorPickerButton}
				/>
				<div className="sc-mymaps-symbolizer-slider opacity">
					<input
						key={"sc-mymaps-symbolizer-stroke-opacity"}
						type="range"
						style={{ width: "150px", marginLeft: "12px" }}
						min={props.sliderStrokeOpacityMin}
						max={props.sliderStrokeOpacityMax}
						value={props.strokeAlpha}
						step="0.05"
						onChange={props.onStrokeOpacitySliderChange}
					/>
				</div>
			</div>
		</React.Fragment>
	);
};

export const StrokeWidth = (props) => {
	return (
		<React.Fragment>
			<label className="sc-mymaps-sub-label">Hrúbka:</label>
			<div className="sc-mymaps-symbolizer-slider size">
				<input
					type="range"
					style={{ width: "191px", marginLeft: "0px" }}
					min={props.sliderStrokeWidthMin}
					max={props.sliderStrokeWidthMax}
					value={props.strokeWidth}
					step="0.5"
					onChange={props.onStrokeWidthSliderChange}
				/>
			</div>
		</React.Fragment>
	);
};

export const Rotation = (props) => {
	return (
		<React.Fragment>
			<label className={props.visible ? "sc-mymaps-style-label" : "sc-hidden"}>Uhol:</label>
			<div className={props.visible ? "sc-mymaps-angle-slider" : "sc-hidden"}>
				<div className="sc-mymaps-symbolizer-slider angle">
					<input type="range" min={props.sliderRotationMin} max={props.sliderRotationMax} value={props.rotation} step="0.1" onChange={props.onRotationSliderChange} />
				</div>
			</div>
		</React.Fragment>
	);
};
